import { getAvailableYears } from '../../services/csvDataService';

export const AVAILABLE_YEARS = getAvailableYears();
export const FAVORITES_STORAGE_KEY = 'new-results-favorite-teams-v1';
export const EQUIPES_FILTERS_STORAGE_KEY = 'new-results-equipes-filters-v1';
export const JOUEURS_FILTERS_STORAGE_KEY = 'new-results-joueurs-filters-v1';

export const JOUEURS_URL_PARAM_KEYS = [
	'licTypes', 'licType', 'licCats', 'licCat', 'pclubs', 'pclub',
	'minManches', 'minParties', 'psize', 'ppage', 'q',
];
export const EQUIPES_URL_PARAM_KEYS = ['eqZone', 'cat', 'club'];
export const COMPETITION_URL_PARAM_KEYS = [
	'zone', 'championship', 'category', 'round', 'view', 'team',
];
export const LOCAL_ONLY_URL_PARAM_KEYS = [
	...JOUEURS_URL_PARAM_KEYS,
	...EQUIPES_URL_PARAM_KEYS,
];

export const PLAYER_PAGE_SIZE_OPTIONS = [20, 50, 100, 250];
export const DEFAULT_PLAYER_PAGE_SIZE = 100;
export const MULTI_FILTER_SEPARATOR = '|';

export const MAIN_TABS = [
	{ id: 'competitions', label: 'Compétitions' },
	{ id: 'equipes', label: 'Équipes' },
	{ id: 'joueurs', label: 'Joueurs' },
	{ id: 'carriere', label: 'Carrière' },
];

export const SUB_VIEWS = [
	{ id: 'manches', label: 'Manches' },
	{ id: 'classement', label: 'Classement' },
	{ id: 'joueurs', label: 'Joueurs' },
];

export const PLAYERS_MOBILE_LABEL_MAX = 20;
